import { render, staticRenderFns } from "./EditEmails.vue?vue&type=template&id=538c3e12"
import script from "./EditEmails.vue?vue&type=script&setup=true&lang=js"
export * from "./EditEmails.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports